import { createContext } from "react";
import type { ViewContextData, ViewContextValue } from "./viewContextProvider";

export type ViewContextType = {
    viewContext: ViewContextData;
    setViewContextValue: (key: string, value: ViewContextValue) => void;
    getViewContext: () => ViewContextData | null;
};

export const ViewContext = createContext<ViewContextType | undefined>(undefined);
